import React from 'react';

const DotsSpinner = ({
  size = 40,
  dotCount = 8,
  dotColor = "#2E7D32", // Light green
  dotSize = 6,
  speed = "1s",
  className = "",
  ...props
}) => {
  const dots = Array.from({ length: dotCount }, (_, i) => {
    const angle = (i / dotCount) * (2 * Math.PI);
    const radius = size / 2 - dotSize;
    const x = size / 2 + radius * Math.cos(angle);
    const y = size / 2 + radius * Math.sin(angle);
    
    return { x, y, delay: (i / dotCount) * 1.5 };
  });

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      className={className}
      {...props}
    >
      <style>{`
        @keyframes dotPulse {
          0%, 100% { opacity: 0.2; transform: scale(0.8); }
          50% { opacity: 1; transform: scale(1.2); }
        }
      `}</style>
      
      {dots.map((dot, index) => (
        <circle
          key={index}
          cx={dot.x}
          cy={dot.y}
          r={dotSize / 2}
          fill={dotColor}
          style={{
            animation: `dotPulse ${speed} ease-in-out infinite`,
            animationDelay: `${dot.delay}s`,
          }}
        />
      ))}
    </svg>
  );
};

export default DotsSpinner;